import { useCallback } from 'react'
import { useLocale } from '../../context/LocaleContextProvider'
import { AnalyticsEvents } from '../../types/analytics/analyticsEvents.enum'
import { LinkClickedEventProperties } from '../../types/analytics/analyticsEventProperties'
import { useSendGTMEvent } from './useSendGTMEvent'
import { useSendSegmentEvent } from './useSendSegmentEvent'

export const useSendLinkClickedEvent = () => {
  const { sendSegmentTrackEvent } = useSendSegmentEvent<LinkClickedEventProperties>()
  const sendGTMEvent = useSendGTMEvent<LinkClickedEventProperties>()
  const { locale } = useLocale()

  const sendLinkClickedEvent = useCallback(
    (linkClickedEventProperties: LinkClickedEventProperties) => {
      const eventProperties = { ...linkClickedEventProperties, page_locale: locale }
      sendSegmentTrackEvent(AnalyticsEvents.LINK_CLICKED, eventProperties)
      sendGTMEvent(AnalyticsEvents.LINK_CLICKED, eventProperties)
    },
    [sendSegmentTrackEvent, sendGTMEvent, locale],
  )

  return sendLinkClickedEvent
}
